<ion-split-pane when="never" contentId="main-content">
  <ion-menu [disabled]="isAuthPage" menu-id="main-menu" contentId="main-content" (ionDidOpen)="menuOpened()" (ionDidClose)="menuClosed()">
    <ion-content color="white">
      <ion-list lines="none">
        <ion-menu-toggle auto-hide="false">
          <div class="section top">
            <ion-item *ngFor="let p of appPages" (click)="navigate(p.url)" color="white">
              <ion-label l10nTranslate class="mainItem">
                {{ p.title }}
              </ion-label>
              <ion-icon class="arrow" src="/assets/icon/appMenuArrowIndicator.svg"></ion-icon>
            </ion-item>
            <ion-item *ngIf="themeService.modul.visitShop === 1" (click)="browse('shop')" color="white">
              <ion-label l10nTranslate class="mainItem"> Menu.shop </ion-label>
              <ion-icon class="arrow" src="/assets/icon/appMenuArrowIndicator.svg"></ion-icon>
            </ion-item>
          </div>

          <app-language-selection></app-language-selection>

          <div class="section bottom">
            <ion-item *ngIf="themeService.modul.profile === 1" (click)="openProfile()" color="white">
              <ion-label l10nTranslate class="regular" color="medium"> Menu.Profile </ion-label>
            </ion-item>
            <ion-item *ngIf="themeService.modul.visitShop === 1" (click)="browse('litello')" color="white">
              <ion-label l10nTranslate class="regular" color="medium"> Menu.AboutLitello </ion-label>
            </ion-item>
            <ion-item *ngIf="isNative" (click)="openLocalStorage()" color="white">
              <ion-label l10nTranslate class="regular" color="medium"> Menu.LocalStorage </ion-label>
            </ion-item>
            <ion-item *ngIf="themeService.modul.changelog === 1" (click)="openChangelog()" color="white">
              <ion-label l10nTranslate class="regular" color="medium"> Menu.Changelog </ion-label>
            </ion-item>

            <ion-item *ngIf="themeService.modul.credits === 1" (click)="openCredits()" color="white">
              <ion-label l10nTranslate class="regular" color="medium"> Menu.Credits </ion-label>
            </ion-item>

            <ion-item *ngIf="themeService.modul.contactSupport === 1" (click)="openContactSupport()" color="white">
              <ion-label l10nTranslate class="regular" color="medium"> Menu.Support </ion-label>
            </ion-item>

            <ion-item
              (click)="browse('impressum')"
              color="white"
              *ngIf="isDesktop && themeService.modul.legalNote === 1"
            >
              <ion-label l10nTranslate class="regular" color="medium"> Menu.Imprint </ion-label>
            </ion-item>

            <ion-item
              (click)="openThemeSwitcher()"
              color="white"
              *ngIf="isDesktop && themeService.modul.themeSwitcher === 1"
            >
              <ion-label l10nTranslate class="regular" color="medium"> Menu.ThemeSwitcher </ion-label>
            </ion-item>

            <ion-item (click)="browse('datenschutz')" color="white" *ngIf="isDesktop">
              <ion-label l10nTranslate class="regular" color="medium"> Menu.DataPrivacy </ion-label>
            </ion-item>

            <ion-item (click)="openImprint()" color="white" *ngIf="isNative">
              <ion-label l10nTranslate class="regular" color="medium"> Menu.Imprint </ion-label>
            </ion-item>

            <ion-item (click)="openDataPrivacy()" color="white" *ngIf="isNative">
              <ion-label l10nTranslate class="regular" color="medium"> Menu.DataPrivacy </ion-label>
            </ion-item>

            <ion-item (click)="logoutUser()" color="white">
              <ion-label l10nTranslate class="logout"> Authentication.LogoutButton </ion-label>
            </ion-item>
          </div>
        </ion-menu-toggle>
      </ion-list>
    </ion-content>
    <ion-item color="white">
      <div class="copyright-version">
        <div>©{{ currentYear }} Litello GmbH</div>
        <div>Version: {{ version }}</div>
      </div>
    </ion-item>
  </ion-menu>
  <ion-router-outlet id="main-content" animated="false"></ion-router-outlet>
</ion-split-pane>
